import type { Hearing } from "@/lib/public-hearings/types";

export type ZoneTone = "policy" | "dc" | "upzone";

// "policy" if there are no district codes (statutory plan amendment);
// "dc" if the destination is a single Direct Control district;
// otherwise default upzone.
export function deriveZoneTone(h: Hearing): ZoneTone {
  if (h.fromDistricts.length === 0 && h.toDistricts.length === 0) {
    return "policy";
  }
  if (h.toDistricts.length === 1 && h.toDistricts[0]?.toUpperCase() === "DC") {
    return "dc";
  }
  return "upzone";
}
